import React from "react";

const OptimizedImage = ({
  src,
  alt,
  width,
  height,
  priority = false,
  loading,
  className = "",
  sizes,
  style,
}) => {
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading || (priority ? "eager" : "lazy")}
      fetchPriority={priority ? "high" : undefined}
      decoding="async"
      className={className}
      sizes={sizes}
      style={style}
    />
  );
};

export default OptimizedImage;